<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import Swal from "sweetalert2";
import { mapActions, mapGetters } from "vuex/dist/vuex.cjs.js";
import $cookies from "vue-cookies";
import Pagination from "../../../components/pagination.vue";
import formatter from "../../../mixins/formatter";
export default {
    page: {
        title: "Search Entries",
        meta: [
            {
                name: "description",
                content: appConfig.description,
            },
        ],
    },
    components: {
        Layout,
        PageHeader,
        Pagination,
    },
    mixins: [
        formatter
    ],
    data() {
        return {
            title: "Search Entries",
            loading: true,
            totalWingband: 0,
            searchCookies: $cookies.get("searchCookies"),
            submitToggle: true,
            search: {
                year: "",
                chapter: "",
                stag_registry: "",
                breeders: "",
                wingband_id: "",
            },
            selectedButton: "All",
            buttons: [
                { label: 'All', value: 0 },
                { label: 'Early Bird', value: 1 },
                { label: 'Local', value: 2 },
                { label: 'National', value: 3 },
                { label: 'Late Born', value: 4 },
                { label: 'Genesis', value: 5 },
            ],
            selectedButtonValue: 0,
            data: {
                list: [],
                total: 0,
                links: [],
                current_page: 1,
                per_page: 1,
                last_page: 1,
            },
            data_markings: {
                list: [],
                total: 0,
                links: [],
                current_page: 1,
                per_page: 1,
                last_page: 1,
            },
            filter: {
                limit: 10,
            },
            editWholeTable: false,
            wingband_data: [
                {
                    stag_number: '',
                    breeders: '',
                    farm_name: '',
                    farm_address: '',
                    province: '',
                    chapter: '',
                    contact_number: '',
                    wingband_number: '',
                    feather_color: '',
                    leg_color: '',
                    comb_shape: '',
                    nose_markings: '',
                    feet_markings: '',
                    disableStag: false,
                    disableWingBand: false,
                }
            ],
            selectedWingbands: [],
            allChapters: [],
            showArchiveModal: false,
            archiveYear: new Date().getFullYear().toString(),
        };
    },
    created() {
        const total = this.$route.query.totalWingband;
        this.totalWingband = total ? parseInt(total, 10) : 0;
    },
    computed: {
        ...mapGetters("auth", ["profile"]),
        ...mapGetters("seasonColors", { seasonColors: "colors" }),
        availableChapters() {
            if (this.profile.role === 'admin') {
                return this.allChapters;
            }
            return this.profile.chapters || [];
        },
        allSelected() {
            return this.data.list.length > 0 && this.selectedWingbands.length === this.data.list.length;
        },
        featherColorOptions() {
            return this.uniqueValues(this.data_markings.list, "feather_color");
        },
        legColorOptions() {
            return this.uniqueValues(this.data.list, "leg_color");
        },
        noseMarkingOptions() {
            return this.uniqueValues(this.data.list, "nose_markings");
        },
        feetMarkingOptions() {
            return this.uniqueValues(this.data.list, "feet_markings");
        },
    },
    methods: {
        ...mapActions("search", {
            searchEntries: "searchEntries",
            wingbandUpdate: "updateWingBand",
            wingbandDelete: "deleteWingband",
            bulkDeleteWingband: "bulkDeleteWingband",
        }),
        ...mapActions("archive", {
            archiveByYear: "archiveByYear",
        }),
        ...mapActions("wingband", {
            getDataList: "getDataList",
        }),
        filterData() {
            this.initList(1);
            this.initListMarkings(1);
        },
        uniqueValues(list, key) {
            if (!Array.isArray(list)) return [];
            const seen = new Set();
            for (const item of list) {
                const val = item && item[key];
                if (val) seen.add(val);
            }
            return Array.from(seen);
        },
        async initListMarkings(p) {
            var pl = {
                page: p,
                limit: this.filter.limit,
                sort: "created_at",
                order: "desc",
            };
            const data = await this.getDataList(pl);
            this.data_markings.list = data.data;
            this.data_markings.links = data.links;
            this.data_markings.current_page = data.current_page;
            this.data_markings.per_page = data.per_page;
            this.data_markings.last_page = data.last_page;
        },
        editTable() {
            if (this.editWholeTable == false) {
                this.editWholeTable = true;
            } else {
                this.editWholeTable = false;
            }
        },
        async submitEdit() {
            var pl = {
                wingband_data: this.data.list,
            }
            const confirmed = await Swal.fire({
                title: "Are you sure?",
                text: "You want to edit this wingband?",
                type: "warning",
                showCancelButton: true,
                padding: "2em",
                icon: "warning",
            }).then((result) => {
                return result.isConfirmed;
            });
            if (confirmed) {
                Swal.fire({
                    title: "Updating...",
                    text: "Saving wingband changes, please wait...",
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                    didOpen: () => {
                        Swal.showLoading();
                    },
                });
                const res = await this.wingbandUpdate(pl);
                if (res && res.status == 200) {
                    Swal.fire({
                        title: "Saved",
                        text: `Wingband updated successfully!`,
                        icon: "success",
                    });
                    this.editWholeTable = false;
                    this.initList(this.data.current_page);
                } else {
                    Swal.fire({
                        title: "Failed",
                        text: (res && res.message) ? res.message : "Something went wrong. Please try again.",
                        icon: "error",
                    });
                }
            }
        },
        async deleteRow(id) {
            var pl = {
                id: id,
            }
            const confirmed = await Swal.fire({
                title: "Are you sure?",
                text: "You want to delete this wingband?",
                type: "warning",
                showCancelButton: true,
                padding: "2em",
                icon: "warning",
            }).then((result) => {
                return result.isConfirmed;
            });
            if (confirmed) {
                const res = await this.wingbandDelete(pl);
                if (res.status == 201) {
                    Swal.fire({
                        title: "Delete",
                        text: `Wingband deleted successfully!`,
                        icon: "success",
                    });
                    this.initList(1);
                    this.editWholeTable = false;
                } else {
                    Swal.fire({
                        title: "Failed",
                        text: res.message,
                        icon: "error",
                    });
                }
            }
        },
        selectRow(selectedItem) {
            const index = this.selectedWingbands.indexOf(selectedItem._id)
            let exists = index > -1
            if (!exists)
                this.selectedWingbands.push(selectedItem._id)
            else
                this.selectedWingbands.splice(index, 1)
        },
        toggleSelectAll() {
            if (this.allSelected) {
                this.selectedWingbands = [];
            } else {
                this.selectedWingbands = this.data.list.map(row => row._id);
            }
        },
        async bulkDelete() {
            console.log('[bulkDelete] selected IDs:', this.selectedWingbands);
            const confirmed = await Swal.fire({
                title: "Bulk Delete",
                text: "You want to delete all the selected wingband?",
                type: "warning",
                showCancelButton: true,
                padding: "2em",
                icon: "warning",
            }).then((result) => {
                return result.isConfirmed;
            });
            console.log('[bulkDelete] confirmed:', confirmed);
            if (confirmed) {
                const res = await this.bulkDeleteWingband({
                    wingband_ids: this.selectedWingbands
                });
                console.log('[bulkDelete] response:', res);
                if (res.status == 200) {
                    Swal.fire({
                        title: "Deleted",
                        text: `Wingbands deleted successfully!`,
                        icon: "success",
                    });
                    this.selectedWingbands=[];
                    this.initList(this.data.current_page);
                    this.editWholeTable = false;
                } else {
                    Swal.fire({
                        title: "Failed",
                        text: res.status == 500 ?'Internal Server Error': res.message,
                        icon: "error",
                    });
                }
            }
        },
        fillStagNumber(value, fromIndex) {
            if (!value) return;
            this.data.list.forEach((row, i) => {
                if (i >= fromIndex) row.stag_registry = value;
            });
        },
        fillBreeders(value, fromIndex) {
            if (!value) return;
            this.data.list.forEach((row, i) => {
                if (i >= fromIndex) row.breeder_name = value;
            });
        },
        fillFarmName(value, fromIndex) {
            if (!value) return;
            this.data.list.forEach((row, i) => {
                if (i >= fromIndex) row.farm_name = value;
            });
        },
        fillFarmAddress(value, fromIndex) {
            if (!value) return;
            this.data.list.forEach((row, i) => {
                if (i >= fromIndex) row.farm_address = value;
            });
        },
        fillProvince(value, fromIndex) {
            if (!value) return;
            this.data.list.forEach((row, i) => {
                if (i >= fromIndex) row.province = value;
            });
        },
        fillChapter(value, fromIndex) {
            if (!value) return;
            this.data.list.forEach((row, i) => {
                if (i >= fromIndex) row.chapter = value;
            });
        },
        fillContactNumber(value, fromIndex) {
            if (!value) return;
            this.data.list.forEach((row, i) => {
                if (i >= fromIndex) row.contact_number = value;
            });
        },
        convertToCsv(objArray) {
            const array = typeof objArray !== "object" ? JSON.parse(objArray) : objArray;
            let str = "";
            for (let i = 0; i < array.length; i++) {
                let line = "";
                for (const index in array[i]) {
                    if (line !== "") line += ",";
                    const val = String(array[i][index] ?? '').replace(/"/g, '""');
                    line += `"${val}"`;
                }
                str += line + "\r\n";
            }
            return str;
        },
        exportCsvFile(headers, items, fileTitle) {
            if (headers) items.unshift(headers);
            const csv = this.convertToCsv(JSON.stringify(items));
            const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
            const link = document.createElement("a");
            if (link.download !== undefined) {
                const url = URL.createObjectURL(blob);
                link.setAttribute("href", url);
                link.setAttribute("download", fileTitle + ".csv");
                link.style.visibility = "hidden";
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }
        },
        async exportAll() {
            var pl = {
                page: 1,
                limit: 5000,
                sort: "created_at",
                status: 1,
            };
            if (this.selectedButtonValue) pl['season'] = this.selectedButtonValue;
            if (this.search.stag_registry) pl['stag_registry'] = this.search.stag_registry;
            if (this.search.breeders) pl['breeder_name'] = this.search.breeders;
            if (this.search.wingband_id) pl['wingband_number'] = this.search.wingband_id;
            if (this.search.chapter) pl['chapter'] = this.search.chapter;
            if (this.searchCookies) {
                pl['wingband_year'] = this.searchCookies;
            } else if (this.search.year) {
                pl['wingband_year'] = this.search.year;
            }
            Swal.fire({ title: 'Exporting...', text: 'Fetching all records, please wait...', allowOutsideClick: false, didOpen: () => Swal.showLoading() });
            try {
                var allRecords = [];
                var currentPage = 1;
                var lastPage = 1;

                do {
                    pl.page = currentPage;
                    var data = await this.searchEntries(pl);
                    var pageData = (data && data.data && data.data.data) ? data.data.data : [];
                    allRecords = allRecords.concat(pageData);
                    lastPage = (data && data.data && data.data.last_page) ? data.data.last_page : 1;
                    currentPage++;
                    Swal.update({ text: 'Fetching page ' + (currentPage - 1) + ' of ' + lastPage + '... (' + allRecords.length + ' records)' });
                } while (currentPage <= lastPage);

                if (allRecords.length === 0) {
                    Swal.fire({ icon: 'info', title: 'No Data', text: 'No records found for the current filters.' });
                    return;
                }
                const headers = {
                    stag_registry: "STAG REGISTRY NO.",
                    breeder_name: "NAME OF BREEDERS",
                    farm_name: "FARM NAME",
                    farm_address: "FARM ADDRESS",
                    province: "PROVINCE",
                    chapter: "CHAPTER",
                    contact_number: "CONTACT NO.",
                    wingband_number: "WINGBAND NO.",
                    feather_color: "FEATHER COLOR",
                    leg_color: "LEG COLOR",
                    comb_shape: "COMB SHAPE",
                    nose_markings: "NOSE MARKINGS",
                    feet_markings: "FEET MARKINGS",
                    wingband_date: "DATE",
                    season_name: "SEASON",
                };
                const itemsFormatted = allRecords.map(item => ({
                    stag_registry: item.stag_registry || '',
                    breeder_name: item.breeder_name || '',
                    farm_name: item.farm_name || '',
                    farm_address: item.farm_address || '',
                    province: item.province || '',
                    chapter: item.chapter || '',
                    contact_number: item.contact_number || '',
                    wingband_number: item.wingband_number || '',
                    feather_color: item.feather_color || '',
                    leg_color: item.leg_color || '',
                    comb_shape: item.comb_shape || '',
                    nose_markings: item.nose_markings || '',
                    feet_markings: item.feet_markings || '',
                    wingband_date: item.wingband_date || '',
                    season_name: item.season_name || '',
                }));
                const current = new Date();
                const dateStr = `${current.getDate()}-${current.getMonth() + 1}-${current.getFullYear()}`;
                this.exportCsvFile(headers, itemsFormatted, `SearchEntries_Export_${dateStr}`);
                Swal.fire({ icon: 'success', title: 'Export Complete', text: allRecords.length + ' records exported successfully.', timer: 3000, timerProgressBar: true });
            } catch (error) {
                Swal.fire({ icon: 'error', title: 'Export Failed', text: 'Failed to fetch records for export.' });
            }
        },
        fillDate(value, fromIndex) {
            if (!value) return;
            this.data.list.forEach((row, i) => {
                if (i >= fromIndex) row.wingband_date = value;
            });
        },
        fillWingbandNumber(value, fromIndex) {
            if (!value) return;
            this.data.list.forEach((row, i) => {
                if (i >= fromIndex) {
                    row.wingband_number = String(value++);
                    row.hasDuplicate = false;
                }
            });
        },
        checkForDuplicates() {
            const countMap = {};
            this.data.list.forEach(row => {
                if (row.wingband_number) {
                    countMap[row.wingband_number] = (countMap[row.wingband_number] || 0) + 1;
                }
            });
            this.data.list.forEach(row => {
                row.hasDuplicate = countMap[row.wingband_number] > 1;
                if (row.hasDuplicate) {
                    Swal.fire({
                        title: "Warning",
                        text: `Check Duplicate Wingband Number`,
                        icon: "warning",
                        showCancelButton: false,
                        showConfirmButton: true,
                    })
                }
            });
        },
        async initList(p) {
            var pl = {
                page: p,
                limit: this.filter.limit,
                sort: "created_at",
                status: 1,
            };
            if (this.selectedButtonValue) {
                pl['season'] = this.selectedButtonValue;
            }
            if (this.search.stag_registry) {
                pl['stag_registry'] = this.search.stag_registry;
            }
            if (this.search.breeders) {
                pl['breeder_name'] = this.search.breeders;
            }
            if (this.search.wingband_id) {
                pl['wingband_number'] = this.search.wingband_id;
            }
            if (this.search.chapter) {
                pl['chapter'] = this.search.chapter;
            }
            if (this.searchCookies) {
                pl['wingband_year'] = this.searchCookies;
                $cookies.set('searchCookies', this.searchCookies);
            } else if (this.search.year) {
                pl['wingband_year'] = this.search.year;
                $cookies.set('searchCookies', this.search.year);
            }

            this.loading = true;

            try {
                const data = await this.searchEntries(pl);

                this.data.list = Array.isArray(data && data.data && data.data.data) ? data.data.data : [];
                this.data.total = (data && data.data && data.data.total) || 0;
                this.data.links = (data && data.data && data.data.links) || [];
                this.data.current_page = (data && data.data && data.data.current_page) || 1;
                this.data.per_page = (data && data.data && data.data.per_page) || 1;
                this.data.last_page = (data && data.data && data.data.last_page) || 1;
            } catch (error) {
                console.error(error);

                this.data.list = [];
                this.data.total = 0;

                Swal.fire({
                    title: "Error",
                    text: "Failed to load data",
                    icon: "error",
                });
            }

            this.loading = false;
        },
        async submitSearch() {
            this.initList(1);
        },
        resetFilter() {
            this.search.year = "";
            this.search.chapter = "";
            this.search.stag_registry = "";
            this.search.breeders = "";
            this.search.wingband_id = "";
            this.searchCookies = null;
            $cookies.remove("searchCookies");
            this.selectedButton = "All";
            this.selectedButtonValue = 0;
            this.filter.limit = 10;
            this.initList(1);
        },
        selectButton(button) {
            this.selectedButton = button.label;
            this.selectedButtonValue = button.value;
            this.initList(1);
        },
        getSeasonBtnColor(button) {
            var colorMap = {
                'All': '#343a40',
                'Early Bird': this.seasonColors.early_bird || '#6F42C1',
                'Local': this.seasonColors.local || '#28A745',
                'National': this.seasonColors.national || '#FFC107',
                'Late Born': this.seasonColors.late_born || '#ADB5BD',
                'Genesis': this.seasonColors.genesis || '#0DCAF0',
            };
            return colorMap[button.label] || '#343a40';
        },
        async submitArchiveYear() {
            if (!this.archiveYear) return;
            var confirmed = await Swal.fire({
                title: "Archive Year " + this.archiveYear,
                html: "This will archive <strong>ALL</strong> Search Entries for year <strong>" + this.archiveYear + "</strong>.<br><br><span class='text-warning'><i class='bx bx-error'></i> This action can be restored later from the Archive Module.</span>",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#dc3545",
                confirmButtonText: "Archive",
            }).then(function(r) { return r.isConfirmed; });
            if (confirmed) {
                var res = await this.archiveByYear({ year: this.archiveYear });
                if (res && res.data && res.data.archived_count > 0) {
                    Swal.fire({ icon: "success", title: "Archived!", text: res.message, timer: 3000, timerProgressBar: true });
                    this.showArchiveModal = false;
                    this.initList(1);
                } else if (res && res.message) {
                    Swal.fire({ icon: "info", title: "No Records", text: res.message });
                } else {
                    Swal.fire({ icon: "error", title: "Failed", text: "Could not archive." });
                }
            }
        },
    },
    mounted() {
        this.initList(1);
        this.initListMarkings();
        if (this.profile.role === 'admin') {
            this.$store.dispatch("chapter/getAll", { limit: 200 })
                .then(res => {
                    this.allChapters = res && res.data ? (res.data.data || res.data) : [];
                });
        }
    },
};
</script>

<template>
    <Layout>
        <PageHeader :title="title" :items="items">
            <button class="btn btn-info text-white" @click="$refreshPage()"><i class='bx bx-refresh'></i> Refresh</button>
        </PageHeader>
        <div class="row">
            <div class="col-lg-12">
                <div class="card mb-2 pb-1">
                    <div class="card-body pb-2">
                        <h4 class="mb-2 fw-bolder">Season</h4>
                        <div class="d-flex flex-wrap gap-2 mb-2">
                            <button
                                v-for="(button, index) in buttons"
                                :key="index"
                                class="season-btn"
                                :class="{ active: selectedButton === button.label }"
                                :style="{ backgroundColor: getSeasonBtnColor(button) }"
                                @click="selectButton(button)">
                                {{ button.label }}
                            </button>
                        </div>
                        <hr>
                        <h4 class="mb-2 mt-2 fw-bolder">Information</h4>
                        <div class="col-12 d-flex flex-wrap">
                            <div class="col-12 col-md-10">
                                <div class="grid-2">
                                    <div class="disflex custom-border p-1" v-if="searchCookies">
                                        <label class="filter-label">Banding Year</label>
                                        <input v-model.lazy="searchCookies" type="text" class="form-control"
                                            placeholder="Enter banding year...">
                                    </div>
                                    <div class="disflex custom-border p-1" v-else-if="!searchCookies">
                                        <label class="filter-label">Banding Year</label>
                                        <input v-model.lazy="search.year" type="text" class="form-control"
                                            placeholder="Enter banding year...">
                                    </div>
                                    <div class="disflex custom-border p-1">
                                    </div>
                                </div>
                                <div class="grid-2">
                                    <div class="disflex custom-border p-1">
                                        <label class="filter-label">Chapter</label>
                                        <select v-model="search.chapter" class="form-control">
                                            <option value="">-- Select Chapter --</option>
                                            <option
                                                v-for="c in availableChapters"
                                                :key="c.id"
                                                :value="c.chapter"
                                            >{{ c.chapter }}</option>
                                        </select>
                                    </div>
                                    <div class="disflex custom-border p-1">
                                        <label class="filter-label">Stag Registry No.</label>
                                        <input v-model.lazy="search.stag_registry" type="text" class="form-control"
                                            placeholder="Enter stag registry no...">
                                    </div>
                                </div>
                                <div class="grid-2">
                                    <div class="disflex custom-border p-1">
                                        <label class="filter-label">Name of Breeders</label>
                                        <input v-model.lazy="search.breeders" type="text" class="form-control"
                                            placeholder="Enter name of breeders...">
                                    </div>
                                    <div class="disflex custom-border p-1">
                                        <label class="filter-label">Wingband ID No.</label>
                                        <input v-model.lazy="search.wingband_id" type="text" class="form-control"
                                            placeholder="Enter wingband id no...">
                                    </div>
                                </div>
                            </div>
                            <div class="col-2">
                                <div class="d-flex flex-column justify-content-center align-items-center h-100 custom-border gap-2">
                                    <button class="btn btn-success py-4 px-5" @click="submitSearch()">Submit</button>
                                    <button class="btn btn-secondary px-5" @click="resetFilter()">Reset</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <h2 class="text-secondary text-center"><span v-if="data.total"> {{ numToString(data.total) }}</span> Entries</h2>
                <div class="card p-0">
                    <div class="p-2 custom-overflow">
                        <div class="d-flex justify-content-between pb-2">
                            <div class="d-flex align-items-center">
                                <label class="filter-label">Limit:</label>
                                <select class="form-control w-25" v-model.lazy="filter.limit" @change="filterData()">
                                    <option value="10">10</option>
                                    <option value="25">25</option>
                                    <option value="50">50</option>
                                    <option value="100">100</option>
                                    <option value="200">200</option>
                                    <option value="500">500</option>
                                    <option value="1000">1000</option>
                                    <option value="5000">5000</option>
                                </select>
                            </div>
                            <div class="text-end px-2 pb-2" v-if="profile.role == 'admin' || profile.role == 'encoder'">
                                <button class="btn btn-success mx-1" v-if="this.editWholeTable && profile.role == 'admin'"
                                    @click="submitEdit()">Save</button>
                                <button v-if="profile.role == 'admin'" :class="!editWholeTable ? 'btn btn-warning mx-1' : 'btn btn-light mx-1'"
                                    @click="editTable()">{{ !this.editWholeTable ? 'Edit' : 'Cancel' }}</button>
                                <button class="btn btn-danger mx-1" v-if="!this.editWholeTable && profile.role == 'admin'" :disabled="!selectedWingbands.length"
                                    @click="bulkDelete">Bulk Delete</button>
                                <button class="btn btn-light mx-1" v-if="!this.editWholeTable" @click="exportAll()">
                                    <i class='bx bx-export'></i> Export All
                                </button>
                                <button class="btn btn-outline-danger mx-1" v-if="!this.editWholeTable && profile.role == 'admin'" @click="showArchiveModal = true">
                                    <i class='bx bx-archive-in'></i> Archive Year
                                </button>
                            </div>
                        </div>
                        <!-- Shared datalists: declared once for the whole table (not per row)
                             so the <option> count stays small no matter how many rows load. -->
                        <template v-if="editWholeTable">
                            <datalist id="feather-color">
                                <option v-for="(val, i) in featherColorOptions" :key="'f' + i" :value="val"></option>
                            </datalist>
                            <datalist id="leg-color">
                                <option v-for="(val, i) in legColorOptions" :key="'l' + i" :value="val"></option>
                            </datalist>
                            <datalist id="nose-marking">
                                <option v-for="(val, i) in noseMarkingOptions" :key="'n' + i" :value="val"></option>
                            </datalist>
                            <datalist id="feet-marking">
                                <option v-for="(val, i) in feetMarkingOptions" :key="'ft' + i" :value="val"></option>
                            </datalist>
                        </template>
                        <table class="mb-0 table">
                            <thead>
                                <tr class="bg-light">
                                    <th>
                                        <input
                                            class="form-check-input"
                                            type="checkbox"
                                            :checked="allSelected"
                                            @change="toggleSelectAll"
                                        />
                                    </th>
                                    <th>Stag Registry No.</th>
                                    <th>Name of Breeders</th>
                                    <th>Farm Name</th>
                                    <th>Farm Address</th>
                                    <th>Province</th>
                                    <th>Chapter</th>
                                    <th>Contact No.</th>
                                    <th>Wingband No.</th>
                                    <th>Feather Color</th>
                                    <th>Leg Color</th>
                                    <th>Comb Shape</th>
                                    <th>Nose Markings</th>
                                    <th>Feet Markings</th>
                                    <th>Date</th>
                                    <th>Season</th>
                                    <th v-if="!editWholeTable && profile.role == 'admin'">Action</th>
                                </tr>
                            </thead>
                            <tbody v-if="!loading">
                                <template v-if="Array.isArray(data.list) && data.list.length > 0">
                                    <tr v-for="(row, index) in data.list" :key="index" class="selectable">
                                        <template v-if="!editWholeTable">
                                            <td >
                                                <input
                                                    class="form-check-input select-row"
                                                    style="margin:0 5px"
                                                    type="checkbox"
                                                    :checked="selectedWingbands.includes(row._id)"
                                                    @change="selectRow(row)"
                                                />
                                            </td>
                                            <td>{{ row.stag_registry }}</td>
                                            <td>{{ row.breeder_name }}</td>
                                            <td>{{ row.farm_name }}</td>
                                            <td>{{ row.farm_address }}</td>
                                            <td>{{ row.province }}</td>
                                            <td>{{ row.chapter }}</td>
                                            <td>{{ row.contact_number }}</td>
                                            <td>{{ row.wingband_number }}</td>
                                            <td>{{ row.feather_color }}</td>
                                            <td>{{ row.leg_color }}</td>
                                            <td>{{ row.comb_shape }}</td>
                                            <td>{{ row.nose_markings }}</td>
                                            <td>{{ row.feet_markings }}</td>
                                            <td>{{ row.wingband_date }}</td>
                                            <td>{{ row.season_name }}</td>
                                            <td v-if="profile.role == 'admin'">
                                                <button class="btn btn-danger btn-sm"
                                                    @click="deleteRow(row._id)">Delete</button>
                                            </td>
                                        </template>
                                        <template v-else>
                                            <td></td>
                                            <td>
                                                <input class="form-control" v-model="row.stag_registry"
                                                    @keydown.ctrl.enter="fillStagNumber(row.stag_registry, index)" />
                                            </td>
                                            <td>
                                                <input class="form-control" v-model="row.breeder_name"
                                                    @keydown.ctrl.enter="fillBreeders(row.breeder_name, index)" />
                                            </td>
                                            <td>
                                                <input class="form-control" v-model="row.farm_name"
                                                    @keydown.ctrl.enter="fillFarmName(row.farm_name, index)" />
                                            </td>
                                            <td>
                                                <input class="form-control" v-model="row.farm_address"
                                                    @keydown.ctrl.enter="fillFarmAddress(row.farm_address, index)" />
                                            </td>
                                            <td>
                                                <input class="form-control" v-model="row.province"
                                                    @keydown.ctrl.enter="fillProvince(row.province, index)" />
                                            </td>
                                            <td>
                                                <select class="form-control" v-model="row.chapter"
                                                    @change="fillChapter(row.chapter, index)">
                                                    <option value="" disabled>-- Select --</option>
                                                    <option v-for="c in availableChapters" :key="c.id" :value="c.chapter">
                                                        {{ c.chapter }}
                                                    </option>
                                                </select>
                                            </td>
                                            <td>
                                                <input class="form-control" v-model="row.contact_number"
                                                    @keydown.ctrl.enter="fillContactNumber(row.contact_number, index)" />
                                            </td>
                                            <td>
                                                <input class="form-control" v-model="row.wingband_number"
                                                    @input="checkForDuplicates"
                                                    @keydown.ctrl.enter="fillWingbandNumber(row.wingband_number, index)"
                                                    :class="{ 'is-invalid': row.hasDuplicate }" />
                                            </td>
                                            <td>
                                                <input class="form-control" type="text" placeholder="Feather Color"
                                                    name="featherColor" list="feather-color" id="featherColor"
                                                    v-model.lazy="row.feather_color">
                                            </td>
                                            <td>
                                                <input class="form-control" type="text" placeholder="Leg Color"
                                                    name="legColor" list="leg-color" id="legColor"
                                                    v-model.lazy="row.leg_color">
                                            </td>
                                            <td><input class="form-control" v-model.lazy="row.comb_shape" /></td>
                                            <td>
                                                <input class="form-control" type="text" placeholder="Nose Markings"
                                                    name="nose-marking" list="nose-marking" id="nose-marking"
                                                    v-model.lazy="row.nose_markings" />
                                            </td>
                                            <td>
                                                <input class="form-control" type="text" placeholder="Feet Markings"
                                                    name="feetMarking" list="feet-marking" id="feetMarking"
                                                    v-model.lazy="row.feet_markings" />
                                            </td>
                                            <td>
                                                <input class="form-control" type="date" name="wingband_date" 
                                                    v-model="row.wingband_date"
                                                    @keydown.ctrl.enter="fillDate(row.wingband_date, index)" />
                                            </td>
                                            <td>{{ row.season_name }}</td>
                                        </template>
                                    </tr>
                                </template>

                                <tr v-else>
                                    <td colspan="17" class="text-center text-muted py-3">
                                        No data found
                                    </td>
                                </tr>
                                
                            </tbody>

                        </table>
                        <div v-if="loading" class="loader">Loading...</div>
                    </div>
                    <Pagination :data="data" @emitPage="initList" class="me-2" />
                </div>
            </div>
        </div>
    </Layout>

    <!-- Archive Year Modal -->
    <b-modal v-model="showArchiveModal" centered title="Archive Search Entries" title-class="font-18" hide-footer>
        <div class="mb-3">
            <label class="form-label fw-semibold">Archive Year</label>
            <select class="form-control" v-model="archiveYear">
                <option v-for="y in 10" :key="y" :value="String(new Date().getFullYear() - y + 1)">
                    {{ new Date().getFullYear() - y + 1 }}
                </option>
            </select>
        </div>
        <div class="alert alert-info d-flex align-items-start mb-2">
            <i class="bx bx-info-circle fs-5 me-2 mt-1"></i>
            <span>This will archive <strong>ALL</strong> Search Entries for year <strong>{{ archiveYear }}</strong>.</span>
        </div>
        <div class="alert alert-warning d-flex align-items-start mb-0">
            <i class="bx bx-error fs-5 me-2 mt-1"></i>
            <span>This action can be restored later from the Archive Module.</span>
        </div>
        <div class="d-flex justify-content-end gap-2 mt-3">
            <button class="btn btn-secondary" @click="showArchiveModal = false">Cancel</button>
            <button class="btn btn-danger" @click="submitArchiveYear()">Archive</button>
        </div>
    </b-modal>
</template>

<style scoped>
th,
td {
    width: 75px !important;
    text-align: start;
}

.table> :not(caption)>*>* {
    text-align: center;
    padding: .5rem .1rem .5rem .1rem !important;
}

th {
    text-transform: uppercase;
}

tr.selectable:has(.select-row:checked) {
    background-color: #e4e8f9;
}

.season-btn {
    padding: 10px 28px;
    border: none;
    border-radius: 6px;
    font-weight: 700;
    font-size: 14px;
    letter-spacing: 0.3px;
    cursor: pointer;
    color: #fff;
    transition: opacity 0.15s, transform 0.1s;
    opacity: 0.75;
    white-space: nowrap;
    flex-shrink: 0;
}

.season-btn:hover {
    opacity: 0.9;
    transform: translateY(-1px);
}

.season-btn.active {
    opacity: 1;
    box-shadow: 0 3px 10px rgba(0,0,0,0.25);
    transform: translateY(-1px);
}
</style>